// services/courses.js
import api from './api';

// Helper functions that match the API pattern mentioned in the task
const getQuery = (endpoint, options = {}) => {
  const { params, ...otherOptions } = options;
  return api.get(endpoint, { params, ...otherOptions });
};

const create = (endpoint, data) => {
  return api.post(endpoint, data);
};

const get = (endpoint, options = {}) => {
  const { params, ...otherOptions } = options;
  return api.get(endpoint, { params, ...otherOptions });
};

const post = (endpoint, data) => {
  return api.post(endpoint, data);
};

export const CoursesAPI = {
  // Get active courses list
  getActiveCourses: (params = {}) => getQuery("courses/list", { params }),
  
  // Create course coupons
  createCourseCoupons: (id, data) => create(`courses/${id}/coupons`, data),
  
  // Get course coupons
  getCourseCoupons: (params = {}) => getQuery("course_coupons", { params }),
  
  // Initiate coupon payment
  initiateCouponPayment: (id, data) => create(`course_coupons/initiate_payment/${id}`, data),
  
  // Get discounted users by course
  getDiscountedUsers: (courseId, params = {}) => getQuery(`course_coupons/discounted_users_by_course/${courseId}`, { params }),
};